import React from "react";
import styles from "./styles.module.scss";

interface DeepActionSectionProps {
  onDownloadClick: () => void;
}

/**
 * 深度操作部分组件
 * 展示通过一个提示自动化执行复杂网络任务的功能
 */
const DeepActionSection = ({ onDownloadClick }: DeepActionSectionProps) => {
  return (
    <div className={styles.container}>
      <div className={styles.stickyContent}>
        {/* Top Section - Title and Description (Fixed) */}
        <div className={styles.topSection}>
          <div className={styles.contentWrapper}>
            <h2 className={styles.sectionTitle}>Your browser, now a personal assistant.</h2>
            <p className={styles.sectionDescription}>Fellou lets you automate complex workflow with one prompt.</p>
          </div>
        </div>

        {/* Middle Section - Video (Flexible based on remaining space) */}
        <div className={styles.videoContainer}>
          <video autoPlay muted loop playsInline className={styles.videoElement}>
            <source
              src="https://fellou.s3.us-west-1.amazonaws.com/videos/website-main-page/Website+main+page+animation/Deep+action.webm"
              type="video/webm"
            />
          </video>
        </div>
      </div>
    </div>
  );
};

export default DeepActionSection;
